module.exports = __webpack_public_path__ + "static/example_form_letter-3bd406f46c7517f337585b64d70896cc.png";